import type React from "react";
import {
  FluentProvider,
  createLightTheme,
  createDarkTheme,
  type BrandVariants,
} from "@fluentui/react-components";
import { useAtomValue } from "jotai";
import { darkModeAtom, isRTLAtom } from "../store";

// GTA Qatar brand — primary Maroon #8A1538 (source: gta.gov.qa custom.css --maroon token,
// verified 2026-07-15). Body typeface Cairo (Google Fonts, OFL license) — free
// Latin+Arabic unified geometric sans, visually equivalent to Qatar's national Lusail
// typeface used across gta.gov.qa and dhareeba.gov.qa.
const brandTheme: BrandVariants = {
  10: '#1a0509',
  20: '#2f0913',
  30: '#420c1a',
  40: '#560f22',
  50: '#6d0f2c',
  60: '#7a1231',
  70: '#831434',
  80: '#8A1538',
  90: '#9d2749',
  100: '#af3d5c',
  110: '#c05770',
  120: '#d17384',
  130: '#dd9099',
  140: '#e8adae',
  150: '#f2c8c5',
  160: '#fbe4dd',
};

const bodyFontStack = '"Cairo", "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif';
const lightTheme = { ...createLightTheme(brandTheme), fontFamilyBase: bodyFontStack };
const darkTheme = { ...createDarkTheme(brandTheme), fontFamilyBase: bodyFontStack };

export const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const darkMode = useAtomValue(darkModeAtom);
  const isRTL = useAtomValue(isRTLAtom);

  const theme = darkMode ? darkTheme : lightTheme;

  return (
    <FluentProvider theme={theme} dir={isRTL ? "rtl" : "ltr"}>
      {children}
    </FluentProvider>
  );
};
